import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const MenuGroupContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") MenuGroupContext.displayName = "MenuGroupContext";
function useMenuGroupRootContext() {
  const context = React.useContext(MenuGroupContext);
  if (context === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuGroupContext is missing. Menu group parts must be used within <Menu.Group> or <Menu.RadioGroup>." : formatErrorMessage(31));
  }
  return context;
}
export {
  MenuGroupContext,
  useMenuGroupRootContext
};
//# sourceMappingURL=MenuGroupContext.js.map
